import { render, staticRenderFns } from "./PasswordForgotten.vue?vue&type=template&id=35a73980&scoped=true&"
import script from "./PasswordForgotten.vue?vue&type=script&lang=js&"
export * from "./PasswordForgotten.vue?vue&type=script&lang=js&"
import style0 from "./PasswordForgotten.vue?vue&type=style&index=0&id=35a73980&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a73980",
  null
  
)

export default component.exports